import React, { useState } from 'react';
import SideMenu from './SideMenu';
import { Layout, Image } from 'antd';
import Logo from '../../assets/images/logo-r.png';
import Layer from '../../assets/images/Layer.png';
import LogOut from '../../assets/images/logout.png';
import { Link, useLocation } from 'react-router-dom';
const { Sider, Content } = Layout;

const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const keysToRemove = ['secretKey', 'stime', 'token'];
  return (
    <Layout style={{ minHeight: '100vh', padding: 0 }}>
      {/* Chỉ hiển thị sider nếu không phải trang login */}
      {location.pathname !== "/login" && (
        <Sider
          trigger={null}
          collapsible
          width={250}
          collapsed={collapsed}
          style={{ backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '30px 0px 30px 0px' }}
        >

          <div style={{ textAlign: 'center', marginBottom: '20px', marginTop: '30px' }}>
            <Image
              style={{ width: collapsed ? '50px' : '150px', transition: 'all 0.3s' }}
              src={Logo}
              preview={false}
            />
          </div>

          <div style={{ flex: 1, width: '250px' }}>
            <SideMenu />
          </div>

          <div style={{ textAlign: 'center', position: 'fixed', bottom: 30, display:'flex', alignItems:'center', justifyContent:'center', width: 250}}>
            <div>
              <Image
                style={{ width: 180, transition: 'all 0.3s', marginBottom: '10px', height: 120 }}
                src={Layer}
                preview={false}
              />
              <div onClick={()=>keysToRemove.forEach((key) => localStorage.removeItem(key))} style={{ display: 'flex', justifyContent: 'center' }}>
                <Link to="/login" style={{ display: 'block', marginTop: '10px', fontSize: '14px', textDecoration: 'none', color: '#333' }}>
                  Đăng xuất
                  <Image
                    style={{ width: '18px', height: '18px', marginLeft: '7px', marginTop: '10px', transition: 'all 0.3s', marginBottom: '10px' }}
                    src={LogOut}
                    preview={false}
                  />
                </Link>
              </div>
            </div>
          </div>
        </Sider>
      )}

      <Layout>
        <Content style={{ padding: 24, minHeight: 280, background: '#F0F2F5' }} >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
